/**
 * Created by tomers on 12/24/2014.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var BaseCollection = require("collections/BaseCollection");
    var ListGroupModel = require("ui/list/js/models/ListGroupModel");

    var ListGroupsCollection = BaseCollection.extend({
        model: ListGroupModel,

        initialize: function(options) {
            var groupsOrder = _.has(options, "groupsOrder") ? options.groupsOrder : [];
            this.setGroupsOrder(groupsOrder);
            this.setComparator(this._comparator);
        },
        _comparator: function(item) {
            var isSpecialGroup = item.isSpecialGroup();

            var groupOrder;
            if (!_.isEmpty(this.getGroupsOrder())) {
                groupOrder = _.indexOf(this.getGroupsOrder(), item.id);
            }
            else {
                groupOrder = item.id.toString().toLowerCase();
            }
            return [isSpecialGroup, groupOrder];
        },
        getGroupsOrder: function() {
            return this.groupsOrder;
        },
        setGroupsOrder: function(groupsOrder) {
            this.groupsOrder = groupsOrder;
        },
        getComparator: function() {
            return this.comparator;
        },
        setComparator: function(comparator) {
            this.comparator = comparator;
        },
        setItemsComparator: function(itemsComparator) {
            this.each(function(groupModel) {
                groupModel.setItemsComparator(itemsComparator);
            });
        },
        getItemsComparator: function() {
            var itemsComparator = null;
            if (this.size() > 0) {
                itemsComparator = this.at(0).getItemsComparator;
            }
            return itemsComparator;
        }
    });

    ListGroupsCollection.Model = ListGroupModel;

    return ListGroupsCollection;

});
